// ModalComponent.jsx
import React from 'react';
import Modal from 'react-modal';
import "./style.css";

const ModalComponent = ({ isOpen, onClose, products }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content"
      overlayClassName="modal-overlay"
      contentLabel="Progresso de Fabricação"
      ariaHideApp={false}
    >
      <div className="modal-header">
        <h2>Progresso de Fabricação</h2>
        <button type="button" onClick={onClose} className="close-button">&times;</button>
      </div>
      <div className="modal-body">
        <div className="product-cards">
          {products.map((product, productIndex) => (
            <div key={productIndex} className="product-card">
              <h3 className="product-name">{product.produto}</h3>
              <div className="sectors">
                {product.setores.map((sector, sectorIndex) => (
                  <div key={sectorIndex} className="sector">
                    <span className="sector-name">{sector.setor}</span>
                    <span className="sector-status">
                      {sector.dtinicio === null ? (
                        <span className="status-icon status-x">&#10060;</span>
                      ) : sector.dttermino === null ? (
                        <span className="status-icon status-dots">...</span>
                      ) : (
                        <span className="status-icon status-check">&#9989;</span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ModalComponent;
